<template>
    <!--页面加载动画-->
    <div
        class="items"
        :name="selectData.elementCode"
        :data-path="selectData.elementPath"
    >
        <div class="items-wrap">
            <span class="lables">
                {{ selectData.elementName }}
                <i
                    class="iconfont icon-wenhao informLayer"
                    v-if="selectData.elementDescribe"
                    @click="showContent = true"
                ></i>
            </span>
            <div class="from-right">
                <span class="elementLabel" v-if="selectData.elementLabel">{{
                    selectData.elementLabel
                }}</span>
                <span
                    class="in-text"
                    v-if="
                        selectData.disabledB && selectData.elementValue == '1'
                    "
                    >投保</span
                >
                <span
                    class="in-text"
                    v-else-if="
                        selectData.disabledB && selectData.elementValue == '2'
                    "
                    >不投保</span
                >
                <van-switch
                    v-else-if="!readOnly"
                    v-model="value"
                    size="40px"
                    active-color="#0084ff"
                    inactive-color="#808080"
                    @change="change"
                />
            </div>
        </div>
        <div class="tagBox" v-if="tags && tags.length > 0">
            <span class="tag" v-for="(item, i) in tags">{{ item }}</span>
        </div>
        <van-popup
            v-model="showContent"
            :lock-scroll="false"
            round
            closeable
            position="bottom"
            :style="{ height: '50%' }"
        >
            <div class="content-popup">
                <div class="content-title">{{ selectData.elementName }}</div>
                <div class="contentBox" v-if="contents && contents.length > 0">
                    <p class="content" v-for="(item, i) in contents">
                        {{ item }}
                    </p>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
var timor;
export default {
    data() {
        return {
            value: false,
            showContent: false, //是否显示内容弹窗
            tags: null, //标签
            contents: null, //弹窗内容
            successValue: 1,
            falseValue: 2,
            readOnly: false,
        };
    },
    props: ["selectData"],
    mounted() {
        //   初始化数据
        this.tags = this.selectData.tags;
        if (
            this.selectData.replaceValue &&
            this.selectData.replaceValue.length > 0
        ) {
            const [
                successValue = 1,
                falseValue = 2,
            ] = this.selectData.replaceValue;
            this.successValue = successValue;
            this.falseValue = falseValue;
        }
        this.getValue();
        if (this.selectData.elementDescribe) {
            let contents = this.selectData.elementDescribe.split("<br>");
            this.contents = contents;
        }
    },
    methods: {
        getValue() {
            this.value = this.selectData.elementValue == this.successValue;
        },
        change(e) {
            this.getResult();
        },
        getResult() {
            //选择后回调到父组件
            let value = this.value
                ? _.clone(this.successValue)
                : _.clone(this.falseValue);
            this.selectData.elementValue = value.toString();
            this.$emit("selected", {
                type: 1,
                item: this.selectData,
                value: value,
            });
        },
    },
    watch: {
        selectData(newVal) {
            this.getValue();
        },
    },
};
</script>

<style lang="scss" scoped>
.items {
    .lables {
        width: 60%;
    }
    .from-right {
        width: 38%;
        display: flex !important;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        .elementLabel {
            color: #ff6e06;
            margin-right: 15px;
        }
    }
    .tagBox {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .tag {
            display: inline-block;
            font-size: 24px;
            color: #007aae;
            background-color: #c8ebfa;
            padding: 3px 10px;
            margin-right: 5px;
            border-radius: 5px;
            margin-bottom: 10px;
        }
    }

    .content-popup {
        padding: 0 30px;

        .content-title {
            line-height: 60px;
            padding-top: 20px;
            padding-bottom: 20px;
            font-size: 34px;
            color: #000;
            font-weight: 900;
            border-bottom: 1px solid #eee;
        }
        .contentBox {
            padding-top: 20px;
            padding-bottom: 20px;
        }
        .content {
            font-size: 30px;
            text-indent: 2em;
            color: #666;
            margin-bottom: 5px;
            line-height: 1.5;
        }
    }
    /deep/ .van-popup__close-icon {
        font-size: 44px;
    }
}
</style>
